import axiosInstance from "../Common/Axios/axiosInstance";
import axiosInstanceClient from "../Common/Axios/axiosInstanceClient";
import API from "../Common/Endpoint/serviceConstrants";

/* Cart calls return the standard ResponseDTO body
   ({ httpStatusCode, errorCode, errorMessage, response }).
   Add-to-cart uses callAddToCartPostApi from addToCartApi.js. */

/* GET /user-cart-by-member-id -> CartDto. A member with no cart gets an empty cart. */
export const callFetchCartApi = async (memberId) => {
  const { data } = await axiosInstanceClient.get(API.userCartByMemberId, {
    params: { MemberId: memberId },
  });
  return data;
};

/* GET /productlist?sku=A,B -> ProductListDTO. Only products are returned to the saga. */
export const callCartProductDetailsApi = async (skuIds) => {
  const { data } = await axiosInstance.get(API.productList, {
    params: { sku: skuIds.join(","), pageNumber: 1, pageSize: skuIds.length },
  });
  const response = Array.isArray(data?.response) ? data.response[0] : data?.response;
  return { ...data, response: response?.products || [] };
};
